import React from 'react';
import classNames from 'classnames';

type Props = {
  content: string,
  target?: string,
  href: string,
  disabled?: boolean,
  outline?: boolean,
  outlineDark?: boolean,
  dataId?: string,
};

function LinkButton(props: Props) {
  const {
    content,
    target,
    href,
    disabled,
    outline,
    outlineDark,
    dataId,
  } = props;
  const btnClass = classNames({
    disabled,
    'bttn--primary': !outline,
    'bttn-outline bttn-outline--primary': outline,
    'bttn-outline--dark': outlineDark,
  });
  return (
    <a
      className={btnClass}
      target={target}
      rel="noopener noreferrer"
      href={href}
      data-automation-id={dataId && dataId}
    >
      <span className="bttn__content">{content}</span>
    </a>
  );
}

LinkButton.defaultProps = {
  target: '_self',
  disabled: false,
  outline: false,
  outlineDark: false,
  dataId: null,
};

export default LinkButton;
